// extracted by css-extract-rspack-plugin
export default {"ColumnGroupName":"BreakoutColumnList-module__ColumnGroupName___dgPpc"};